import riot from 'riot';
module.exports = riot.observable();


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/context/observable.js